import { classNames } from "primereact/utils";

import { LOADING_LABEL } from "../state-message/messages";
import { Skeleton } from "./skeleton";
import styles from "./skeleton.module.scss";
import type { TableSkeletonViewProps } from "./types-skeleton";

/** Esqueleto de tabela (`rows` × `columns`) sobre o `Skeleton` do DS: região `role="status"` com nome "Carregando…" e blocos `aria-hidden`. */
export function TableSkeletonView({
  className,
  style,
  size,
  testId,
  rowTestId,
  rows,
  columns,
  rest,
}: TableSkeletonViewProps) {
  return (
    <div
      className={classNames(styles.table, className)}
      style={style}
      role="status"
      aria-label={LOADING_LABEL}
      aria-busy="true"
      data-size={size}
      data-testid={testId}
      {...rest}
    >
      {rows.map((row) => (
        <div key={row} className={styles.row} data-testid={rowTestId}>
          {columns.map((column) => (
            <Skeleton key={column} aria-hidden />
          ))}
        </div>
      ))}
    </div>
  );
}
